<template lang="pug">
div
  .pa-2.mx-1.my-10
    v-row
      v-col.pa-6(cols=12 lg=5)
        v-row(justify="start")
          v-col(cols=10 lg=12)
            div.text-h3.primary--text.font-weight-bold EV Trip Planner
            div.mt-4.text-h5.primary--text.font-weight-bold Where are you going?
          v-col.mx-2(cols=1 justify="end" v-if="mobile")
            v-menu
              template(v-slot:activator="{ on, attrs }")
                v-btn(color="primary"  dark  v-bind="attrs" v-on="on" icon)
                  v-icon mdi-dots-vertical
              v-list
                v-list-item
                  v-btn(v-on:click="signup" block text) Sign Up
                v-list-item
                  v-btn(v-on:click="login" block text) Login
                v-list-item
                  v-btn(v-on:click="drivingDetails" block text) EV Finder
        v-row
          v-col.pa-6
            VerticalTripCard(:trip="trip")
            v-row(justify="center")
              v-col(cols=8)
                v-row(justify="center")
                  v-btn.primary.my-10(v-if="!mobile" v-on:click="routePlanning", block) Plan My Trip
      v-col.pa-6(cols=12 lg=1)
        v-spacer
      v-col.pa-6(cols=12 lg=5)
        v-row.mt-1(v-if="!mobile")
          v-col
            v-btn(v-on:click="signup" block outlined elevation=1) Sign Up
          v-col
            v-btn(v-on:click="login" block outlined elevation=1) Login
          v-col
            v-btn(v-on:click="drivingDetails" block outlined elevation=1) EV Finder
        v-row
          v-col
            div.text-h5.primary--text.font-weight-bold Which EV are you driving?
        v-row
          v-col
            CarModelSelector(:models="modelData" :selectedCar="selectedCar" :driver="driver" @updateSelected="updateCar")
        v-row(justify="center")
          v-col(cols=8)
            v-row(justify="center")
              v-btn.primary.my-10(v-if="mobile" v-on:click="routePlanning", block) Plan My Trip

    v-row(align="center", justify="end")
      v-col(cols=3)
        v-spacer
        em(style="font-size: 0.8em;margin-left:5px;") Powered by
        v-img(src="https://powersell.appstack.me/logo.png", width=100)
</template>

<script>
import VerticalTripCard from "../components/VerticalTripCard";
import CarModelSelector from "../components/CarModelSelector";
import Vue from 'vue';
export default {
  components: { VerticalTripCard, CarModelSelector },
  data() {
    return {
      selectedCar:  null,
            driver: {
        aa: 50,
        sa: 0,
        soh: 100,
        battery: 100,
        passengers: 1,
        batteryMin: 20,
        batteryMax: 95,
        extraWeight: 0
      },
      trip: {
        id: 1,
        title: "My Trip",
        frequency: 1,
        frequencyUnit: "workday",
        viaAddresses: [],
        fromAddress: { Address: null },
        toAddress: { Address: null },
        path: [],
      },
    };
  },
  mounted() {
    if (this.$route.query.state) {
      let state = this.$route.query.state;
      let loadState = this.loadState;
      setTimeout(function () {
        loadState(state);
      }, 1000);
    }
        Vue.prototype.$Countly.q.push([
      "add_event",
      {
        key: "Route Planner Landing Page",
        segmentation: {
          dealer: this.$dealer.default_settings.name,
        },
      },
    ]);

    if (localStorage.getItem("driver")) {
      this.driver = JSON.parse(localStorage.getItem("driver"));
    }
  },
  methods: {
    updateCar(newCar) {
      const parsed = JSON.stringify(newCar);
      localStorage.setItem("car", parsed);
    },
    drivingDetails() {
      this.$router.push("recommender/0");
    },
    routePlanning() {
      this.$trips.length = 0;
      this.$trips.push(this.trip);
      this.$router.push("planner");
    },
    regularTrips() {
      this.$router.push("recommender/1");
    },
    dealerAdmin() {
      this.$router.push("dealer");
    },
    signup(){
      this.$router.push("/new");
    },
    login() {
      this.$router.push("/login");
    }
  },

};
</script>

<style scoped>
.v-card > h2,
.subtitle {
  color: #1e88e5;
  font-weight: bold;
}
a {
  text-decoration: none;
}
.right {
  float: right;
}
.v-card p {
  text-align: center;
}
.v-card .v-image {
  transform: translate(-50%, 0);
  left: 50%;
  opacity: 0.6;
}
.icon-image {
  opacity: 0.5;
  float: right;
}
.white {
  filter: invert(1);
  mix-blend-mode: lighten;
}
</style>